import { searchService } from '@services';
import { BaseFacetComponent } from '../base-facet.component';
import defaultHtml from './search-within-facet.component.hbs';

export class SearchWithinFacetComponent extends BaseFacetComponent {
    protected override customTemplatePropertyName = 'searchWithinFacet';
    protected override defaultHtml = defaultHtml;

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data) {
            return '';
        }

        const html = template({
            value: this.data.searchWithin ?? ''
        });

        return html;
    }

    protected bindChildElements(): void {
        this.shadowRoot?.querySelectorAll('[hawksearch-input]').forEach((e) => {
            e.addEventListener('change', (event: Event) => {
                event.preventDefault();

                const element = event.currentTarget as HTMLInputElement;
                const value = element.value.trim();

                searchService.searchWithin(value);
            });
        });
    }
}
